import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'number',
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss']
})
export class NumberComponent implements OnInit {

  @Input()
  public good: 'positive' | 'negative' | 'none' = 'positive';

  @Input()
  public decimal: number = 2;

  @Input()
  public value: number;

  @Input()
  public sign: boolean = true;

  public get display(): number {
    return this.sign ? this.value : Math.abs(this.value);
  }

  public get isGood(): boolean {
    switch (this.good) {
      case 'positive': return this.value > 0;
      case 'negative': return this.value < 0;
      default: return false;
    }
  }

  public get isBad(): boolean {
    switch (this.good) {
      case 'positive': return this.value < 0;
      case 'negative': return this.value > 0;
      default: return false;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
